import { useState, useCallback } from 'react'

const MIN_LOADING_DURATION = 500

type Props<T> = {
  refetch: () => Promise<T>
}

export const useMinLoadingRefetch = <T>({ refetch }: Props<T>) => {
  const [isLoading, setIsLoading] = useState(false)

  const delay = () =>
    new Promise<void>(resolve => setTimeout(resolve, MIN_LOADING_DURATION))

  const handleRefresh = useCallback(async () => {
    setIsLoading(true)

    try {
      await Promise.all([refetch(), delay()])
    } finally {
      setIsLoading(false)
    }
  }, [refetch])

  return {
    isLoading,
    handleRefresh,
  }
}
